import { Box, BoxProps } from "@mui/material";
import React, { ReactNode } from "react";
import { DEFAULT_FONTSIZE } from "../utils/utils";

type GlobalTableHeightWrapperProps = {
  children: ReactNode;
  small?: boolean;
} & BoxProps;

const GlobalTableHeightWrapper: React.FC<GlobalTableHeightWrapperProps> = ({
  children,
  small,
  ...others
}) => (
  <Box
    marginTop={1}
    {...others}
    height={others?.height ?? `calc(100vh - ${small ? "12rem" : "7.2rem"})`}
    fontSize={`${DEFAULT_FONTSIZE.fontSize}`}
  >
    {children}
  </Box>
);

export { GlobalTableHeightWrapper };
